import {
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiMail,
  FiPhone,
  FiMapPin,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import rfaLogo from "../assets/rfa logo.webp";

const Footer = () => {
  return (
    <footer className="bg-[#7D192A] text-white pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto site-gutter">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-12 md:gap-y-10 md:gap-x-8 lg:gap-x-10 mb-12">
          {/* Academy Info & Socials */}
          <div className="space-y-6 min-w-0">
            <Link to="/" className="flex items-center gap-3">
              <img
                src={rfaLogo}
                alt="Reflection Futbol Academy logo"
                width={56}
                height={56}
                className="h-14 w-14 object-contain bg-white rounded-full p-1"
              />
              <div>
                <span className="text-white font-inter font-extrabold text-lg md:text-xl block leading-none">
                  REFLECTION
                </span>
                <span className="text-white font-inter font-extrabold text-lg md:text-xl block leading-none">
                  FUTBOL
                </span>
                <span className="text-[#F4B400] font-inter font-bold text-xs md:text-sm block leading-none">
                  ACADEMY
                </span>
              </div>
            </Link>
            <p className="footer-text text-gray-100/95">
              Reflecting your true potential on the pitch. Join our elite
              football academy and achieve your dreams.
            </p>

            <div className="pt-2">
              <h4 className="font-inter font-bold text-[#F4B400] uppercase tracking-wider mb-4">
                Connect With Us
              </h4>
              <div className="flex gap-4">
                <a
                  href="https://www.facebook.com/reflectionfutbolacademy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#F4B400] hover:border-[#F4B400] hover:text-[#222222] transition-all"
                >
                  <FiFacebook size={20} />
                  <span className="sr-only">Facebook</span>
                </a>
                <a
                  href="https://www.instagram.com/reflectionfutbol.academy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#F4B400] hover:border-[#F4B400] hover:text-[#222222] transition-all"
                >
                  <FiInstagram size={20} />
                  <span className="sr-only">Instagram</span>
                </a>
                <a
                  href="https://twitter.com/reflectionfutbol"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Twitter"
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#F4B400] hover:border-[#F4B400] hover:text-[#222222] transition-all"
                >
                  <FiTwitter size={20} />
                  <span className="sr-only">Twitter</span>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="space-y-6 min-w-0">
            <h4 className="font-inter font-bold text-[#F4B400] uppercase tracking-wider">
              Contact Info
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <FiMapPin
                  className="text-[#F4B400] flex-shrink-0 mt-1"
                  size={20}
                />
                <span className="footer-text text-gray-100">
                  8201 SW 44th St, Oklahoma City, OK 73179
                </span>
              </div>
              <div className="flex items-center gap-3">
                <FiPhone className="text-[#F4B400] flex-shrink-0" size={20} />
                <a
                  href="tel:+14055889793"
                  className="footer-text text-gray-100 hover:text-[#F4B400] transition-colors"
                >
                  +1(405)-588-9793
                </a>
              </div>
              <div className="flex items-start gap-3">
                <FiMail
                  className="text-[#F4B400] flex-shrink-0 mt-1"
                  size={20}
                />
                <a
                  href="mailto:Reflectionfutbolacademy@gmail.com"
                  className="footer-text text-gray-100 break-all hover:text-[#F4B400] transition-colors"
                >
                  Reflectionfutbolacademy@gmail.com
                </a>
              </div>
            </div>
          </div>

          <div className="md:col-span-2 lg:col-span-1 grid grid-cols-1 sm:grid-cols-2 gap-y-10 sm:gap-y-0 sm:gap-x-6 lg:gap-x-5 min-w-0">
            {/* Quick Links */}
            <div className="space-y-6 min-w-0">
              <h4 className="font-inter font-bold text-[#F4B400] uppercase tracking-wider">
                Quick Links
              </h4>
              <ul className="space-y-3 footer-text text-gray-100/95">
                <li>
                  <Link
                    to="/"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/programs"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Programs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pricing"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link
                    to="/apply"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Apply Now
                  </Link>
                </li>
              </ul>
            </div>

            {/* Programs */}
            <div className="space-y-6 min-w-0">
              <h4 className="font-inter font-bold text-[#F4B400] uppercase tracking-wider">
                Programs
              </h4>
              <ul className="space-y-3 footer-text text-gray-100/95">
                <li>
                  <Link
                    to="/programs"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Group Training
                  </Link>
                </li>
                <li>
                  <Link
                    to="/programs"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Individual Training
                  </Link>
                </li>
                <li>
                  <Link
                    to="/programs"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Development Academy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/programs"
                    className="hover:text-[#F4B400] transition-colors"
                  >
                    Goalkeeper Training
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-3 border-t border-white/25 text-center">
          <p className="footer-text text-gray-100">
            &copy; {new Date().getFullYear()} Reflection Futbol Academy. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
